
<div class="tlp">
  <div class="tlp__canvas">
    <header class="tlp__header" aria-label="TITAN">
      <div class="tlp__content-inner tlp__header-inner">
        <div class="tlp__header-brand">
          <img
            class="tlp__logo"
            :src="imageUrl('/shopadmin/logo_lp.svg')"
            alt="TITAN"
            width="120"
            height="36"
            decoding="async" />
          <p class="tlp__tagline">
            飲食店向け インバウンド集客自動化ツール
          </p>
        </div>
        <a
          class="tlp__cta"
          href="https://titan-g.com/signup"
          target="_blank"
          rel="noopener noreferrer">
          無料会員登録
        </a>
      </div>
    </header>
    <section
      class="tlp__promo-banner"
      role="region"
      aria-label="キャンペーン案内">
      <div class="tlp__content-inner tlp__promo-inner">
        <p class="tlp__promo-text">
          【グルプラ会員様限定】初期費用無料＆特別プラン キャンペーン実施中！
        </p>
      </div>
    </section>
    <main class="tlp__main">
      <section
        class="tlp__mv"
        aria-labelledby="titan-lp-mv-heading">
        <div class="tlp__mv-bg" aria-hidden="true">
          <img
            class="tlp__mv-bg-img"
            :src="imageUrl('/shopadmin/mv_bg.jpg')"
            alt=""
            width="3996"
            height="2080"
            fetchpriority="high"
            loading="eager"
            decoding="async" />
        </div>
        <div class="tlp__content-inner tlp__mv-inner">
          <div class="tlp__mv-copy">
            <h1
              id="titan-lp-mv-heading"
              class="tlp__mv-title">
              訪日客を<br />
              取りこぼしたくない<br />
              <span class="tlp__mv-title-pill">飲食店オーナー様</span>へ
            </h1>
            <p class="tlp__mv-lead">
              Googleマップ・検索広告を活用して<br />
              自動でインバウンド集客しませんか？
            </p>
            <p class="tlp__mv-desc">
              Web広告の知識は一切不要。AIが運用を自動化し、<br />
              "見つけられるお店"から"選ばれるお店"へと導きます。
            </p>
            <a
              class="tlp__mv-cta"
              href="https://titan-g.com/signup"
              target="_blank"
              rel="noopener noreferrer">
              <span class="tlp__mv-cta-badge">最短1分、初期費用0円</span>
              <span class="tlp__mv-cta-main">無料会員登録はこちら</span>
            </a>
          </div>
          <div class="tlp__mv-visual">
            <img
              class="tlp__mv-visual-img"
              :src="imageUrl('/shopadmin/mv_right.png')"
              alt=""
              width="625"
              height="859"
              loading="eager"
              decoding="async" />
          </div>
        </div>
      </section>
    </main>
    <section
      class="tlp__problem"
      aria-labelledby="titan-lp-problem-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-problem-title" class="tlp__section-title">
          こんなお悩みはありませんか？
        </h2>
        <div class="tlp__problem-title-bar" aria-hidden="true"></div>
        <ul class="tlp__problem-grid" role="list">
          <li
            v-for="(item, index) in problemItems"
            :key="index"
            class="tlp__problem-card">
            <div class="tlp__problem-card-header">
              <svg class="tlp__problem-icon" width="44" height="44" viewBox="0 0 44 44" fill="none"
                xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path
                  d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z"
                  fill="#FFE2E2" />
                <path
                  d="M22 33.6667C28.4433 33.6667 33.6667 28.4433 33.6667 22C33.6667 15.5567 28.4433 10.3333 22 10.3333C15.5567 10.3333 10.3333 15.5567 10.3333 22C10.3333 28.4433 15.5567 33.6667 22 33.6667Z"
                  stroke="#E7000B" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18.5 22L20.8333 24.3333L25.5 19.6667" stroke="#E7000B" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="tlp__problem-card-text">{{ item.text }}</p>
            </div>
            <img
              class="tlp__problem-card-illust"
              :src="imageUrl(item.illust)"
              alt=""
              width="356"
              height="140"
              loading="lazy"
              decoding="async" />
          </li>
        </ul>
        <div class="tlp__problem-callout" aria-label="まとめ">
          <p class="tlp__problem-callout-line">そのお悩みは、需要がないからではなく、</p>
          <p class="tlp__problem-callout-em">「お店の魅力が訪日客に見つけられていない」</p>
          <p class="tlp__problem-callout-line">だけかもしれません。</p>
        </div>
      </div>
    </section>
    <section
      class="tlp__support"
      aria-labelledby="titan-lp-support-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-support-title" class="tlp__section-title">
          TITANが、訪日客の集客の仕組みを一括でサポート
        </h2>
        <p class="tlp__section-lead">
          専門知識やお時間は一切不要です。AI技術と飲食専門のプロが、<br />
          自動で成果に繋がるシステムを構築いたします。
        </p>
        <div class="tlp__support-grid-wrap">
          <div class="tlp__support-grid-line" aria-hidden="true"></div>
          <ul class="tlp__support-grid" role="list">
            <li
              v-for="(item, index) in supportItems"
              :key="index"
              class="tlp__support-card">
              <div class="tlp__support-card-num" aria-hidden="true">{{ item.num }}</div>
              <div class="tlp__support-card-illust-wrap">
                <img
                  class="tlp__support-card-illust"
                  :src="imageUrl(item.illust)"
                  alt=""
                  width="332"
                  height="180"
                  loading="lazy"
                  decoding="async" />
              </div>
              <h3 class="tlp__support-card-title">{{ item.title }}</h3>
              <p class="tlp__support-card-desc">{{ item.desc }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section
      class="tlp__optimize"
      aria-labelledby="titan-lp-optimize-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-optimize-title" class="tlp__section-title">
          来店までの行動を可視化し、確実に改善
        </h2>
        <p class="tlp__section-lead">
          単なる表示回数ではなく、実来店に直結するアクションを増やします。
        </p>
        <div class="tlp__optimize-flow">
          <img
            class="tlp__optimize-flow-img"
            :src="imageUrl('/shopadmin/optimize_flow.png')"
            alt="来店までの行動を可視化"
            width="611"
            height="179"
            loading="lazy"
            decoding="async" />
        </div>
        <div class="tlp__optimize-features">
          <div class="tlp__optimize-feature-card">
            <div class="tlp__optimize-feature-icon-wrap" aria-hidden="true">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 10.6668V5.3335H10.6667" stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M24 10.6665H8C6.52724 10.6665 5.33333 11.8604 5.33333 13.3332V23.9998C5.33333 25.4726 6.52724 26.6665 8 26.6665H24C25.4728 26.6665 26.6667 25.4726 26.6667 23.9998V13.3332C26.6667 11.8604 25.4728 10.6665 24 10.6665Z"
                  stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.66667 18.6665H5.33333M26.6667 18.6665H29.3333M20 17.3335V20.0002M12 17.3335V20.0002"
                  stroke="#155DFC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="tlp__optimize-feature-content">
              <h3 class="tlp__optimize-feature-title">AIによる自動最適化</h3>
              <p class="tlp__optimize-feature-desc">
                配信開始後は、AIが常に効果を分析。予算内で最大限の効果が得られるよう、表示タイミングやターゲット、入札単価を自動で調整します。
              </p>
            </div>
          </div>
          <div class="tlp__optimize-feature-card">
            <div class="tlp__optimize-feature-icon-wrap tlp__optimize-feature-icon-wrap--orange" aria-hidden="true">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 14.6665H8C8.70724 14.6665 9.38552 14.9475 9.88562 15.4476C10.3857 15.9477 10.6667 16.6259 10.6667 17.3332V21.3332C10.6667 22.0404 10.3857 22.7187 9.88562 23.2188C9.38552 23.7189 8.70724 23.9998 8 23.9998H6.66667C5.95942 23.9998 5.28115 23.7189 4.78105 23.2188C4.28095 22.7187 4 22.0404 4 21.3332V14.6665ZM4 14.6665C4 13.0906 4.31039 11.5302 4.91345 10.0743C5.5165 8.6184 6.40042 7.29553 7.51472 6.18122C8.62902 5.06692 9.95189 4.18301 11.4078 3.57995C12.8637 2.97689 14.4241 2.6665 16 2.6665C17.5759 2.6665 19.1363 2.97689 20.5922 3.57995C22.0481 4.18301 23.371 5.06692 24.4853 6.18122C25.5996 7.29553 26.4835 8.6184 27.0866 10.0743C27.6896 11.5302 28 13.0906 28 14.6665M28 14.6665V21.3332C28 22.0404 27.719 22.7187 27.219 23.2188C26.7189 23.7189 26.0406 23.9998 25.3333 23.9998H24C23.2928 23.9998 22.6145 23.7189 22.1144 23.2188C21.6143 22.7187 21.3333 22.0404 21.3333 21.3332V17.3332C21.3333 16.6259 21.6143 15.9477 22.1144 15.4476C22.6145 14.9475 23.2928 14.6665 24 14.6665H28Z"
                  stroke="#F54900" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M28 21.3335V24.0002C28 25.4147 27.4381 26.7712 26.4379 27.7714C25.4377 28.7716 24.0812 29.3335 22.6667 29.3335H16"
                  stroke="#F54900" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="tlp__optimize-feature-content">
              <h3 class="tlp__optimize-feature-title">飲食のプロによる徹底サポート</h3>
              <p class="tlp__optimize-feature-desc">
                2000店舗以上の支援実績を持つ専門チームが伴走。初期設定から日々の運用相談まで、オンラインで手厚くサポートいたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="tlp__results"
      aria-labelledby="titan-lp-results-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-results-title" class="tlp__section-title">
          圧倒的な導入成果
        </h2>
        <p class="tlp__section-lead">
          インバウンド需要を確実に利益へ繋げています。
        </p>
        <div class="tlp__results-list">
          <article v-for="(item, ri) in resultsItems" :key="ri" class="tlp__results-card">
            <img
              class="tlp__results-card-bg"
              :src="imageUrl('/shopadmin/results_card_bg.svg')"
              alt=""
              aria-hidden="true" />
            <div class="tlp__results-card-body">
              <div class="tlp__results-tags">
                <span class="tlp__results-tag tlp__results-tag--location">{{ item.location }}</span>
                <span class="tlp__results-tag tlp__results-tag--category">{{ item.category }}</span>
                <span class="tlp__results-tag tlp__results-tag--period">{{ item.period }}</span>
              </div>
              <h3 class="tlp__results-card-title">{{ item.title }}</h3>
              <p class="tlp__results-card-desc">{{ item.desc }}</p>
            </div>
            <div class="tlp__results-metrics">
              <div v-for="(metric, mi) in item.metrics" :key="mi" class="tlp__results-metric">
                <div class="tlp__results-metric-before">
                  <span>Before</span>
                  <span>{{ metric.before }}</span>
                </div>
                <div class="tlp__results-metric-name">{{ metric.name }}</div>
                <div class="tlp__results-metric-after">
                  <span class="tlp__results-metric-after-num">{{ metric.afterNum }}</span><span
                    class="tlp__results-metric-after-suffix">{{ metric.afterSuffix }}</span>
                </div>
                <img
                  class="tlp__results-metric-illust"
                  :src="imageUrl(metric.illust)"
                  alt=""
                  loading="lazy"
                  decoding="async" />
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
    <section
      class="tlp__matching"
      aria-labelledby="titan-lp-matching-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-matching-title" class="tlp__section-title">
          TITANがフィットする店舗様
        </h2>
        <div class="tlp__matching-grid">
          <div class="tlp__matching-card tlp__matching-card--fit">
            <h3 class="tlp__matching-card-title">
              <span class="tlp__matching-card-title-icon-wrap" aria-hidden="true">
                <svg class="tlp__matching-card-title-icon" width="28" height="28" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#05DF72" stroke-width="2.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span class="tlp__matching-card-title-text">特に効果を実感いただきやすい<br />店舗様</span>
            </h3>
            <ul class="tlp__matching-list" role="list">
              <li v-for="(item, index) in matchingFitItems" :key="index" class="tlp__matching-item">
                <svg class="tlp__matching-check" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="#00C950" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 12L11 14L15 10" stroke="#00C950" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span class="tlp__matching-text">{{ item }}</span>
              </li>
            </ul>
            <div class="tlp__matching-illust-wrap">
              <img
                class="tlp__matching-illust"
                :src="imageUrl('/shopadmin/matching_illust_fit.png')"
                alt=""
                width="492"
                height="106"
                loading="lazy"
                decoding="async" />
            </div>
          </div>
          <div class="tlp__matching-card tlp__matching-card--unfit">
            <h3 class="tlp__matching-card-title">
              <span class="tlp__matching-card-title-icon-wrap" aria-hidden="true">
                <svg class="tlp__matching-card-title-icon" width="28" height="28" viewBox="0 0 28 28" fill="none"
                  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path d="M5.83325 14H22.1666" stroke="#79716B" stroke-width="3.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
              <span class="tlp__matching-card-title-text">本サービスが合わない可能性が<br />ある店舗様</span>
            </h3>
            <ul class="tlp__matching-list tlp__matching-list--unfit" role="list">
              <li v-for="(item, index) in matchingUnfitItems" :key="index" class="tlp__matching-item">
                <span class="tlp__matching-check-wrap" aria-hidden="true">
                  <svg class="tlp__matching-check" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M5 12H19" stroke="#A6A09B" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                <span class="tlp__matching-text">{{ item }}</span>
              </li>
            </ul>
            <div class="tlp__matching-illust-wrap">
              <img
                class="tlp__matching-illust"
                :src="imageUrl('/shopadmin/matching_illust_unfit.png')"
                alt=""
                width="492"
                height="152"
                loading="lazy"
                decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="tlp__pricing"
      aria-labelledby="titan-lp-pricing-title">
      <div class="tlp__content-inner tlp__pricing-inner">
        <h2 id="titan-lp-pricing-title" class="tlp__section-title">
          まずはリスクを抑えてスタートし、<br />
          実際の来店効果をご実感ください
        </h2>
        <p class="tlp__section-lead">
          不要な固定費を抑え、自動化による効率運用で<br />
          オーナー様の利益最大化を目指します。
        </p>
        <div class="tlp__pricing-card-wrap">
          <div class="tlp__pricing-badge">
            <span class="tlp__pricing-badge-star" aria-hidden="true">✨</span>
            一番人気
            <span class="tlp__pricing-badge-star" aria-hidden="true">✨</span>
          </div>
          <div class="tlp__pricing-card">
            <div class="tlp__pricing-card-header">
              <span class="tlp__pricing-plan-tag">【グルプラ会員様限定】特別プラン</span>
              <h3 class="tlp__pricing-plan-name">システム月額利用料</h3>
              <div class="tlp__pricing-price-wrap">
                <span class="tlp__pricing-price-prefix">毎月</span>
                <span class="tlp__pricing-price-symbol">¥</span>
                <span class="tlp__pricing-price-num">0</span>
              </div>
              <p class="tlp__pricing-price-note">（1店舗あたり）</p>
              <div class="tlp__pricing-condition">
                初期費用:<span class="tlp__pricing-condition-em">無料</span> <span
                  class="tlp__pricing-condition-sep">/</span> 契約期間:1ヶ月〜
              </div>
            </div>
            <div class="tlp__pricing-card-body">
              <ul class="tlp__pricing-features" role="list">
                <li v-for="(item, index) in pricingFeatures" :key="index" class="tlp__pricing-feature-item">
                  <span class="tlp__pricing-feature-check-wrap" aria-hidden="true">
                    <svg class="tlp__pricing-feature-check" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                      <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#05DF72" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span class="tlp__pricing-feature-text">{{ item }}</span>
                </li>
              </ul>
              <div class="tlp__pricing-action">
                <a
                  class="tlp__pricing-btn"
                  href="https://titan-g.com/signup"
                  target="_blank"
                  rel="noopener noreferrer">
                  今すぐ無料会員登録する
                </a>
              </div>
              <div class="tlp__pricing-notes-wrap">
                <div class="tlp__pricing-notes">
                  <p class="tlp__pricing-note">※発生するのは実費の広告費（月額1万円〜）と、その運用手数料（30%）のみとなります。</p>
                  <p class="tlp__pricing-note">※広告費や上位プランへの変更は、管理画面からいつでも設定・確認いただけます。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="tlp__faq"
      aria-labelledby="titan-lp-faq-title">
      <div class="tlp__content-inner">
        <h2 id="titan-lp-faq-title" class="tlp__section-title tlp__faq-title">
          よくあるご質問
        </h2>
        <ul class="tlp__faq-list" role="list">
          <li
            v-for="(item, index) in faqItems"
            :key="index"
            class="tlp__faq-item">
            <button
              type="button"
              class="tlp__faq-trigger"
              :aria-expanded="openFaqIndex === index"
              :aria-controls="`titan-lp-faq-panel-${index}`"
              :id="`titan-lp-faq-trigger-${index}`"
              @click="toggleFaq(index)">
              <span class="tlp__faq-trigger-main">
                <span class="tlp__faq-q-mark" aria-hidden="true">Q.</span>
                <span class="tlp__faq-q-text">{{ item.question }}</span>
              </span>
              <span
                class="tlp__faq-icon"
                :class="{ 'is-open': openFaqIndex === index }"
                aria-hidden="true">
                <span class="tlp__faq-icon-bg">
                  <span class="tlp__faq-icon-glyph">
                    <span class="tlp__faq-icon-line tlp__faq-icon-line--h"></span>
                    <span class="tlp__faq-icon-line tlp__faq-icon-line--v"></span>
                  </span>
                </span>
              </span>
            </button>
            <div
              class="tlp__faq-anim"
              :class="{ 'is-open': openFaqIndex === index }"
              :aria-hidden="openFaqIndex !== index">
              <div class="tlp__faq-anim-inner">
                <div
                  :id="`titan-lp-faq-panel-${index}`"
                  class="tlp__faq-panel"
                  role="region"
                  :aria-labelledby="`titan-lp-faq-trigger-${index}`">
                  <p class="tlp__faq-answer">
                    <span class="tlp__faq-a-mark" aria-hidden="true">A.</span>
                    <span class="tlp__faq-answer-body">{{ item.answer }}</span>
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section
      class="tlp__signup-cta"
      aria-labelledby="titan-lp-signup-cta-title">
      <div
        class="tlp__signup-cta-gradient-wrap"
        aria-hidden="true">
        <div class="tlp__signup-cta-gradient"></div>
      </div>
      <img
        class="tlp__signup-cta-deco tlp__signup-cta-deco--tr"
        :src="imageUrl('/shopadmin/cta_bg_right.png')"
        alt=""
        width="512"
        height="512"
        loading="lazy"
        decoding="async"
        aria-hidden="true" />
      <img
        class="tlp__signup-cta-deco tlp__signup-cta-deco--bl"
        :src="imageUrl('/shopadmin/cta_bg_left.png')"
        alt=""
        width="544"
        height="544"
        loading="lazy"
        decoding="async"
        aria-hidden="true" />
      <div class="tlp__content-inner tlp__signup-cta-inner">
        <h2 id="titan-lp-signup-cta-title" class="tlp__signup-cta-title">
          <span class="tlp__signup-cta-title-row">訪日客のGoogleマップ上の取りこぼしを、</span>
          <span class="tlp__signup-cta-title-row">
            <span class="tlp__signup-cta-highlight">ご来店チャンス</span>
            <span class="tlp__signup-cta-title-tail">に変えませんか？</span>
          </span>
        </h2>
        <p class="tlp__signup-cta-lead">
          あなたのお店が現在どれだけ機会損失しているか、<br />
          システム上ですぐに無料シミュレーションが可能です。
        </p>
        <a
          class="tlp__signup-cta-btn"
          href="https://titan-g.com/signup"
          target="_blank"
          rel="noopener noreferrer">
          無料会員登録はこちら
        </a>
        <ul class="tlp__signup-cta-features" role="list">
          <li
            v-for="(label, index) in signupCtaFeatures"
            :key="index"
            class="tlp__signup-cta-feature">
            <svg
              class="tlp__signup-cta-check"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false">
              <path
                d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
                stroke="#00C950"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M7.5 9.99967L9.16667 11.6663L12.5 8.33301"
                stroke="#00C950"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>{{ label }}</span>
          </li>
        </ul>
      </div>
    </section>
    <footer class="tlp__footer" aria-label="TITAN">
      <img
        class="tlp__footer-logo"
        :src="imageUrl('/shopadmin/logo_lp_white.svg')"
        alt="TITAN"
        width="106"
        height="28"
        decoding="async" />
    </footer>
  </div>
</div>
